import { connect } from 'react-redux';
import { updateCartItem } from '../actions';
import { cartSelector, getCartStatus } from '../selector';
import Cart from '../components/cart';

const mapDispatchToProps = dispatch => {
  const updateHandler = method => ({ id, articleID, qty }) =>
    dispatch(
      updateCartItem(method, {
        id,
        articleID,
        qty,
      })
    );

  return {
    onUpdateCartItem: updateHandler('update'),
    onDeleteCartItem: updateHandler('delete'),
  };
};

const mapStateToProps = state => {
  return {
    cartStatus: getCartStatus(state),
    ...cartSelector(state),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Cart);



// WEBPACK FOOTER //
// ../shop_main/containers/cart.js